const pre = 'accounts/'

export default {
  SEND_SMS_REQUEST: `${pre}SEND_SMS_REQUEST`
}
